document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('.product__subs__wrap');
  if (!widgets.length) return;

  widgets.forEach((subWidget) => {
    try {
      initWidget(subWidget);
    } catch (err) {
      console.error('[subscription-form] init error:', err);
    }
  });

  function initWidget(subWidget) {
    const sectionID = subWidget.getAttribute('data-subSection-id');
    const radios = Array.from(subWidget.querySelectorAll('input[name="selling-plan-group"]'));
    if (!radios.length) return;

    const BASE_VARIANT_FALLBACK = subWidget.querySelector('[data-base-variant-id]')?.value || null;
    const SUB_VARIANT_ID = subWidget.querySelector('[data-sub-variant-id]')?.value || null;
    const planSelect = subWidget.querySelector('#selling_plan_id_select');

    // ---------- helpers ----------
    function getForms() {
      const all = Array.from(document.querySelectorAll('product-form'));
      let forms = all.filter((f) => f.getAttribute('data-section-id') == sectionID);
      if (!forms.length) {
        const info = subWidget.closest('product-info');
        if (info) forms = Array.from(info.querySelectorAll('product-form'));
      }
      return forms;
    }

    function isSubscription() {
      const checked = subWidget.querySelector('input[name="selling-plan-group"]:checked');
      return !!checked && checked.value !== '';
    }

    function currentPlanId() {
      return (
        planSelect?.value ||
        subWidget.querySelector('input[name="current_selling_plan"]:checked')?.value ||
        subWidget.querySelector('input[name="current_selling_plan"]')?.value ||
        ''
      );
    }

    function baseVariantId() {
      return subWidget.querySelector('[data-base-variant-id]')?.value || BASE_VARIANT_FALLBACK;
    }

    // Writes id / selling_plan / free-products into the form to match the selected option
    function syncForm(productForm) {
      const form = productForm.querySelector('form');
      if (!form) return;
      const sub = isSubscription();

      const idInput = form.querySelector('input[name="id"]');
      const variantId = sub && SUB_VARIANT_ID ? SUB_VARIANT_ID : baseVariantId();
      if (idInput && variantId) idInput.value = String(variantId);

      const planValue = sub ? currentPlanId() : '';
      form.querySelectorAll('[name="selling_plan"]').forEach((el) => {
        el.value = planValue;
      });

      // gifts are only for subscriptions
      const gifts = form.querySelector('[name="free-products"]');
      if (gifts) gifts.disabled = !sub;
    }

    function syncAllForms() {
      getForms().forEach(syncForm);
    }

    // ---------- price / serving text (your original logic, null-safe) ----------
    function updatePrices(sub) {
      const attr = sub ? 'new_dis_price_sub' : 'new_price_one';

      document
        .querySelectorAll('.featured-product .bundle_selector_wrapper .bundle_items')
        .forEach((item) => {
          const price = item.getAttribute(attr);
          const el = item.querySelector('.pro_price');
          if (el && price) el.textContent = price + ' / Opakowanie';
        });

      const activeItem = document.querySelector('.bundle_items.active');
      if (!activeItem) return;

      const newPrice = activeItem.getAttribute(attr);
      const lasData = document.querySelector('.featured-product .pre_serving_wrapper .text.las_data');
      if (lasData && newPrice) lasData.textContent = newPrice + ' / serving';

      const servingEl = activeItem.querySelector('.serving_text');
      const serPer = document.querySelector('.featured-product .pre_serving_wrapper .text.ser_per');
      if (servingEl && serPer) serPer.textContent = servingEl.textContent.trim();
    }

    function apply() {
      updatePrices(isSubscription());
      syncAllForms();
    }

    // ---------- events ----------
    radios.forEach((radio) => radio.addEventListener('change', apply));

    if (planSelect) {
      planSelect.addEventListener('change', () => {
        // choosing a frequency selects the subscription option
        const subRadio = radios.find((r) => r.value !== '');
        if (subRadio && !subRadio.checked) {
          subRadio.checked = true;
          subRadio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          apply();
        }
      });
    }

    // Final safety net: re-sync right before the cart submit runs.
    // Capture on <product-form> so this runs before the form's own submit handler.
    getForms().forEach((pf) => {
      if (pf.dataset.subSyncBound === '1') return;
      pf.dataset.subSyncBound = '1';
      pf.addEventListener('submit', () => syncForm(pf), true);
    });

    // ---------- initial state ----------
    apply();                          // immediately, so there is no "wrong" window
    setTimeout(apply, 600);           // re-apply after other scripts (Juo etc.) finish
    window.addEventListener('pageshow', apply); // back/forward cache restore
  }
});